import { observable, action, computed, runInAction, reaction } from "mobx";
import { IWarranty, WarrantySearchFormValues } from "../models/warranty";
import agent from "../api/agent";
import { RootStore } from "./rootStore";
import { format } from "date-fns";


export default class WarrantyStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;

    reaction(
      () => this.predicate.keys(),
      () => {
        this.brand = "";
        this.warrantyRegistry.clear();
        this.loadWarranties();
      }
    );
  }

  @observable warrantyRegistry = new Map();
  @observable warranty: IWarranty | null = null;
  @observable loadingInitial = false;
  @observable submitting = false;
  @observable target = "";
  @observable brand = "Devanti";
  @observable predicate = new Map();
  @observable warrantySearchFormValues: WarrantySearchFormValues | null = null;
  @observable isShowWarrantyDetail = false;
  @observable columnToSort = "warranty_createdAtDisplay";
  @observable sortingOrder = "descending";
  @observable isSelectAll = false;
  @observable defaultActivePageSize = 1;
  @observable totalRecord = 0;
  @observable startRecord = 0;
  @observable endRecord = 0;

  @action setBrand = (brand: string) => {
    this.brand = brand;
  };

  @action setDefaultActivePageSize = (activePage: number) => {
    this.defaultActivePageSize = activePage;
    this.startRecord = this.defaultActivePageSize * 10 - 10;
    this.endRecord = this.defaultActivePageSize * 10;
  };


  @action setFilter = (pars: WarrantySearchFormValues) => {
    this.warrantySearchFormValues = pars;

  };

  @action setShowWarrantyDetail = (isShow: boolean) => {
    this.isShowWarrantyDetail = isShow;
  };

  @action setColumnToSorting = (columnName: string) => {
    this.columnToSort = columnName;
  };
  @action setSortingOrder = (columnOrder: string) => {
    this.sortingOrder = columnOrder;
  };
  @action setIsSelectAll = (isSelect: boolean) => {
    this.isSelectAll = isSelect;

    this.warrantyRegistry.forEach((item) => {
      item.isSelected = isSelect;
    });
  };
  @computed get warrantiesByDate() {
     
    if (this.warrantySearchFormValues != null) {
      let isFilterValue: boolean = false;
      let isExist: boolean = false;
      let filteredListFinal: IWarranty[] = [];
      let filteredList: IWarranty[] = Array.from(
        this.warrantyRegistry.values()
      );

      filteredList.forEach((item) => {
        isExist = false;
        // First Name Filter
        if (this.warrantySearchFormValues?.firstName) {
          isFilterValue = true;
          if (
            this.warrantySearchFormValues?.firstName
              .toLowerCase()
              .includes(item.warranty_firstname.toLowerCase())
          )
            isExist = true;
        }
        // Last Name Filter
        if (this.warrantySearchFormValues?.lastName) {
          isFilterValue = true;
          if (
            this.warrantySearchFormValues?.lastName
              .toLowerCase()
              .includes(item.warranty_lastname.toLowerCase())
          )
            isExist = true;
        }
        // SKU Filter
        if (this.warrantySearchFormValues?.sku) {
          isFilterValue = true;
          if (
            this.warrantySearchFormValues?.sku
              .toLowerCase()
              .includes(item.warranty_sku.toLowerCase())
          )
            isExist = true;
        }
        //Date Filter
        if (this.warrantySearchFormValues?.registrationDateFrom && this.warrantySearchFormValues?.registrationDateTo) {
          isFilterValue = true;
         
          let dateFrom = new Date(this.warrantySearchFormValues?.registrationDateFrom.toDateString());
          let dateTo = new Date(this.warrantySearchFormValues?.registrationDateTo.toDateString());
          dateTo.setHours(23, 59, 59, 0)
          if (item.warranty_createdAt > dateFrom && item.warranty_createdAt < dateTo)
            {isExist = true;
            }
        } else if (this.warrantySearchFormValues?.registrationDateFrom) {
          isFilterValue = true;
          let dateFrom = new Date(this.warrantySearchFormValues?.registrationDateFrom.toDateString());
          if (
            item.warranty_createdAt > dateFrom
          )
            isExist = true;
        } else if (this.warrantySearchFormValues?.registrationDateTo) {
          isFilterValue = true;
          let dateTo = new Date(this.warrantySearchFormValues?.registrationDateTo.toDateString());
          dateTo.setHours(23, 59, 59, 0)
          if (
            item.warranty_createdAt < dateTo
          )
            isExist = true;
        }
       
        if (isExist) {
       
          filteredListFinal.push(item);
        }
      });

      if (isFilterValue) {
      
        return this.groupWarrantiesByDate(filteredListFinal);
      }
      else return this.groupWarrantiesByDate(filteredList);
    }

    return this.groupWarrantiesByDate(
      Array.from(this.warrantyRegistry.values())
    )
  }

  groupWarrantiesByDate(warranties: IWarranty[]) {
    
    switch (this.columnToSort) {
      case "warranty_firstname":
        if (this.sortingOrder === "descending") {
           warranties.sort((a, b) =>
            a.warranty_firstname.toLowerCase() >
            b.warranty_firstname.toLowerCase()
              ? -1
              : 1
          );
        } else if (this.sortingOrder === "ascending") {
           warranties.sort((a, b) =>
            a.warranty_firstname.toLowerCase() >
            b.warranty_firstname.toLowerCase()
              ? 1
              : b.warranty_firstname.toLowerCase() >
                a.warranty_firstname.toLowerCase()
              ? -1
              : 0
          );
        }
       break;
      case "warranty_lastname":
        if (this.sortingOrder === "descending") {
           warranties.sort((a, b) =>
            a.warranty_lastname.toLowerCase() >
            b.warranty_lastname.toLowerCase()
              ? -1
              : 1
          );
        } else if (this.sortingOrder === "ascending") {
           warranties.sort((a, b) =>
            a.warranty_lastname.toLowerCase() >
            b.warranty_lastname.toLowerCase()
              ? 1
              : b.warranty_lastname.toLowerCase() >
                a.warranty_lastname.toLowerCase()
              ? -1
              : 0
          );
        }
        break;
      case "warranty_sku":
        if (this.sortingOrder === "descending") {
           warranties.sort((a, b) =>
            a.warranty_sku.toLowerCase() > b.warranty_sku.toLowerCase() ? -1 : 1
          );
        } else if (this.sortingOrder === "ascending") {
           warranties.sort((a, b) =>
            a.warranty_sku.toLowerCase() > b.warranty_sku.toLowerCase()
              ? 1
              : b.warranty_sku.toLowerCase() > a.warranty_sku.toLowerCase()
              ? -1
              : 0
          );
        }
        break;
      case "warranty_createdAtDisplay":
        if (this.sortingOrder === "descending") {
           warranties.sort((a, b) =>
            a.warranty_createdAt.getTime() > b.warranty_createdAt.getTime()
              ? -1
              : 1
          );
        } else if (this.sortingOrder === "ascending") {
           warranties.sort(
            (a, b) =>
              a.warranty_createdAt.getTime() - b.warranty_createdAt.getTime()
          );
        }
        break;
      case "warranty_purchased_dateDisplay":
        warranties.sort((a, b) => {
          const dateA = a.warranty_purchased_date ? new Date(a.warranty_purchased_date) : new Date('1970-01-01T00:00:00');
          const dateB = b.warranty_purchased_date ? new Date(b.warranty_purchased_date) : new Date('1970-01-01T00:00:00');

          if (this.sortingOrder === "descending") {
            return dateB.getTime() - dateA.getTime(); // 降序
          } else { // ascending
            return dateA.getTime() - dateB.getTime(); // 升序
          }
        });
        break;
      default:
         warranties.sort((a, b) =>
          a.warranty_createdAt.getTime() > b.warranty_createdAt.getTime()
            ? -1
            : 1
        );
        break;
    }

    return warranties;
  }

  @action loadWarranties = async () => {
    this.loadingInitial = true;
    try {
      const warrantiesResponse = await agent.Warranties.list(this.brand);
      const { data } = warrantiesResponse;
      runInAction(() => {
        data.forEach((item) => {
          //temp
          /*  if (item.warranty_id % 2 == 0)
            item.warranty_firstname = item.warranty_firstname.toLowerCase(); */
          item.isSelected = false;
          item.warranty_createdAt = new Date(item.warranty_createdAt);
          // item.warranty_purchased_date = new Date(item.warranty_purchased_date);
          // item.warranty_warranty_end_date = new Date(item.warranty_warranty_end_date);

          item.warranty_createdAtDisplay = format(
            new Date(item.warranty_createdAt),
            "dd/MM/yyyy HH:mm"
          );
          item.warranty_purchased_dateDisplay = item.warranty_purchased_date 
            ? format(new Date(item.warranty_purchased_date),"dd/MM/yyyy HH:mm")
            : '';
          item.warranty_warranty_end_dateDisplay = item.warranty_warranty_end_date
            ? format(new Date(item.warranty_warranty_end_date), "dd/MM/yyyy HH:mm")
            : '';

          this.warrantyRegistry.set(item.warranty_id, item);
        });
        this.startRecord = this.defaultActivePageSize * 10 - 10;
        this.endRecord = this.defaultActivePageSize * 10;
        this.loadingInitial = false;
      });
    } catch (error) {
      runInAction(() => {
        this.loadingInitial = false;
      });
    }
  };

  @action clearWarrantyData = () => {
    this.warrantyRegistry.clear();
  };

  @action clearWarranty = () => {
    this.warranty = null;
  };

  getWarranty = (id: string) => {
    return this.warrantyRegistry.get(id);
  };

  @action editWarranty = async (warranty: IWarranty) => {
    try {
      runInAction("editing activity", () => {
        warranty.isSelected = !warranty.isSelected;
        this.warrantyRegistry.set(warranty.warranty_id, warranty);
      });
    } catch (error) {
      console.log(error);
    }
  };
}
